import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './s2e.png';

const API = 'https://snap2excel-backend.onrender.com';

function LandingPage({ onLogin }) {
  const navigate = useNavigate();
  const [loadingGuest, setLoadingGuest] = useState(false);
  const [error, setError] = useState('');

  // ------------------------------------------------
  // ✅ Handle Guest Login
  // ------------------------------------------------
  const handleGuestLogin = async () => {
    try {
      setError('');
      setLoadingGuest(true);

      const ok = await onLogin("demo@snap2excel.com", "demo1234");

      if (ok !== false) {
        navigate('/app');
      } else {
        setError("Guest login failed (invalid demo account).");
      }

    } catch (err) {
      console.error("Guest login error:", err);
      setError("Guest login failed.");
    } finally {
      setLoadingGuest(false);
    }
  };

  return (
    <div className="landing-root">
      {/* HEADER */}
      <header className="landing-header">
        <img src={logo} alt="Snap2Excel" className="landing-logo" />
        <h1 className="landing-title">Snap2Excel</h1>
        <p className="landing-sub">
          Scan receipts · Track money · Stay in control
        </p>
      </header>

 {/* BUTTONS */}
      <div className="landing-buttons">
        <button
          className="landing-btn-primary"
          onClick={() => navigate('/login')}
        >
          Login
        </button>

        <button
          className="landing-btn-secondary"
          onClick={handleGuestLogin}
          disabled={loadingGuest}
        >
          {loadingGuest ? "Loading…" : "Try as Guest"}
        </button>
      </div>

      {/* FEATURES */}
      <section className="landing-features">
        <div className="landing-card">
          <h3>📸 Scan receipts</h3>
          <p>Drag, drop, and we extract totals & VAT instantly.</p>
        </div>

        <div className="landing-card">
          <h3>💸 Money planner</h3>
          <p>See exactly how much leftover money you truly have.</p>
        </div>

        <div className="landing-card">
          <h3>📊 Smart tracking</h3>
          <p>All your receipts stored safely with monthly summaries.</p>
        </div>
      </section>

      <section className="landing-extra">
  <h2>Why people choose Snap2Excel</h2>

  <div className="landing-extra-grid">
    <div className="extra-item">
      <h4>💰 Saves you money</h4>
      <p>Track spending leaks & keep more money every month automatically.</p>
    </div>

    <div className="extra-item">
      <h4>⚡ Lightning fast scanning</h4>
      <p>Upload a receipt and we extract totals, VAT and dates instantly.</p>
    </div>

    <div className="extra-item">
      <h4>📊 Real-life dashboard</h4>
      <p>Monthly summaries, trends, and smart budgeting insights.</p>
    </div>

    <div className="extra-item">
      <h4>🔒 Secure & private</h4>
      <p>Your data is encrypted & never shared. Ever.</p>
    </div>
  </div>
</section>

      {error && <p className="landing-error">{error}</p>}
    </div>
  );
}

export default LandingPage;
